import {UseFormRegisterReturn} from 'react-hook-form';
import {ReactNode, useState} from "react";

export const InputLogin = ({
                               name,
                               label,
                               type,
                               dir = "rtl",
                               register,
                               error,
                               prefix = "",
                               icon,
                               required = false,
                               value
                           }: {
    name: string;
    label: string | ReactNode;
    type: string;
    dir?: string;
    register: UseFormRegisterReturn;
    error?: string;
    prefix?: string;
    icon?: (isVisible: boolean, toggle: () => void) => React.ReactNode;
    required?: boolean;
    value?: string | never;
}) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => setIsVisible(!isVisible);

    const inputType = type === "password" && isVisible ? "text" : type;

    return (
        <div className="relative">
            {/* Label */}
            <label
                htmlFor={name}
                className="
                    block
                    text-sm
                    font-semibold
                    text-gray-800
                "
            >
                {label}

                {required && (
                    <span className="mr-1 text-red-500">*</span>
                )}
            </label>

            {/* Input */}
            <div className="relative mt-2">
                {prefix && (
                    <span
                        className="
                            absolute
                            left-0
                            top-0
                            bottom-0
                            z-10
                            flex
                            items-center
                            justify-center
                            border-r
                            border-gray-300/70
                            px-3
                            text-sm
                            font-medium
                            text-gray-600
                        "
                        dir="ltr"
                    >
                        {prefix}
                    </span>
                )}

                <input
                    type={inputType}
                    id={name}
                    dir={dir}
                    autoComplete={name}
                    defaultValue={value}
                    {...register}
                    className={`
                        block
                        w-full

                        ${prefix ? "pl-14" : "pl-4"}
                        ${type === "password" ? "pr-12" : "pr-4"}

                        py-3

                        rounded-xl

                        border
                        border-white/80

                        bg-white/55

                        text-base
                        text-gray-900

                        outline-none

                        placeholder:text-gray-400

                        shadow-[
                            inset_0_1px_1px_rgba(255,255,255,0.9),
                            inset_0_-1px_2px_rgba(0,0,0,0.06),
                            0_2px_8px_rgba(0,0,0,0.06)
                        ]

                        backdrop-blur-xl

                        transition-all
                        duration-200

                        hover:bg-white/65
                        hover:border-white

                        focus:bg-white/75
                        focus:border-indigo-300

                        focus:ring-2
                        focus:ring-indigo-400/20

                        focus:shadow-[
                            inset_0_1px_1px_rgba(255,255,255,1),
                            0_4px_15px_rgba(79,70,229,0.12)
                        ]

                        sm:text-sm
                    `}
                />

                {/* Password Icon */}
                {type === "password" && icon?.(isVisible, toggleVisibility)}
            </div>

            {/* Error */}
            <div className="mt-1 min-h-[1.25rem]">
                {error && (
                    <p className="text-xs font-medium text-red-500">
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
};